import styles from './List.css'
import { Pagination } from 'react-bootstrap'
import Row from './Row'

class List extends React.Component {

  constructor (props) {
    super(props)
    this.state = ({ selectedPointActivityId: null })
  }
  render () {
    let {pointActivities} = this.props
    if (!pointActivities) {
      return null
    }

    let views = pointActivities.content.map((pointActivity) => {
      return (
        <Row
          key={pointActivity.row_id}
          onClickRow={this._onClickRow}
          pointActivity={pointActivity}
          isSelected={this.state.selectedPointActivityId === pointActivity.parent_payment_id}
        />
      )
    })

    return (
      <div className={styles['length-wrapper']}>
        <div className={styles['wrapper']}>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles['date']}>Date</th>
                <th className={styles['outlet']}>Outlet</th>
                <th className={styles['sale']}>Sale</th>
                <th className={styles['point']}>Point</th>
              </tr>
            </thead>
          </table>
          <div className={styles['table-content-wrapper']}>
            <table className={styles['table-content']}>
              <tbody>
                {views}
              </tbody>
            </table>
          </div>
        </div>
        <Pagination
          className='pull-right'
          prev
          next
          ellipsis
          boundaryLinks
          items={pointActivities.total_pages}
          maxButtons={5}
          activePage={pointActivities.number + 1}
          onSelect={this._onSelectPageNumber}
        />
      </div>
    )
  }

  _onSelectPageNumber = (eventKey) => {
    this.props.getPointActivity({
      page: eventKey,
      size: 12,
      sort: 'createdAt,desc',
      customerId: this.props.customerDetail.id
    })
    this.setState({selectedPointActivityId: ''})
  }
  _onClickRow = (paymentType, paymentId, pointActivityId) => {
    this.props.openReceipt({
      payment_type: paymentType,
      parent_payment_id: paymentId
    })
    this.setState({selectedPointActivityId: paymentId})
  }
}

export default List



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/PointActivity/List/List.js